module.exports = __webpack_public_path__ + "img/NRam64_ua.1e65d0e1.webp";